import { useEffect, useState } from "react";
import moment from "moment";
import {
  Table,
  TableRow,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  Button,
} from "../../../StyledComponents";
import { Div } from "../../Styles";
import {
  TxtSpan,
  NewTableHeadCell,
  AvatarFrame,
  AvatarTxt,
  NewActionButton,
} from "../styles";
import Loading from "../../../StyledComponents/Loading";
import axiosInst from "../../../../Config";
import { Decrypt_Value } from "../../../../MiddleWare/EncryptDecrypt";
import EmptyData from "../../../StyledComponents/EmptyData";

const StatementTable = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const File_URL = backurl + "/sites/" + DBhost + "/portal_statement_documents";

  useEffect(() => {
    axiosInst
      .get(`vozoportal/getdocumentlist?pid=${Pat_ID}`)
      .then((res) => {
        const decryptedResponse = Decrypt_Value(res.data, "vozoportal");
        setDocuments(decryptedResponse);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const handleDownload = async (pdfPath) => {
    if (!pdfPath) {
      console.error("Invalid PDF Path");
      return;
    }

    try {
      const res = await axiosInst.post(
        `/vozoportal/PreviewDownloadForPatientStatement?pid=${Pat_ID}&filePath=${pdfPath}`,
      );

      if (res.data) {
        var tag = document.createElement("a");
        tag.href = res.data.file;
        tag.download = res.data.filename;
        document.body.appendChild(tag);
        tag.click();
        document.body.removeChild(tag);
      } else {
        console.error("Invalid response format");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleView = (pdfPath) => {
    axiosInst
      .get(`/vozo/patientstatement/appointment?pid=24`)
      .then((res) => { });
    if (!pdfPath) {
      console.error("Invalid PDF Path");
      return;
    }
    const pdfUrl = `${File_URL}/${pdfPath.split("/").pop()}`;
    window.open(pdfUrl, "_blank");
  };

  return (
    <Div>
      {loading ? (
        <Loading height={20} />
      ) : (
        <Table height="auto">
          <TableHead>
            <TableRow
              display="grid"
              tempColumns="22% 20% 18% 18% 22%"
              background="#F1F7FF"
            >
              <NewTableHeadCell textAlign="center" padding="16px 20px">Provider</NewTableHeadCell>
              <NewTableHeadCell padding="16px 20px">Facility</NewTableHeadCell>
              <NewTableHeadCell padding="16px 20px">
                Generated On
              </NewTableHeadCell>
              <NewTableHeadCell padding="16px 20px">
                Statement Balance
              </NewTableHeadCell>
              <NewTableHeadCell textAlign="center" padding="16px 20px">
                Action
              </NewTableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {documents.some(
              (doc) =>
                doc &&
                (doc.provider_name ||
                  doc.facility_name ||
                  doc.document_date ||
                  doc.insurance_balance ||
                  doc.pdf_link),
            ) ? ( // ✅ Corrected conditional rendering
              documents.map((doc, index) => (
                <TableRow
                  key={index}
                  display="grid"
                  tempColumns="22% 20% 18% 18% 22%"
                  alignItems="center"
                >
                  <TableBodyCell padding="16px 20px">
                    <Div display="flex" alignItems="center">
                      <AvatarFrame>
                        <AvatarTxt>
                          {doc?.provider_name
                            ? doc.provider_name.charAt(0)
                            : "P"}
                        </AvatarTxt>
                      </AvatarFrame>
                      <TxtSpan
                        fontWeight="500"
                        color="#1e293b"
                        title={doc?.provider_name}
                        style={{
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: "block",
                          maxWidth: "180px",
                        }}
                      >
                        {doc?.provider_name || "-"}
                      </TxtSpan>
                    </Div>
                  </TableBodyCell>

                  <TableBodyCell padding="16px 20px">
                    <TxtSpan
                      color="#475569"
                      title={doc?.facility_name}
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "block",
                        maxWidth: "180px",
                      }}
                    >
                      {doc?.facility_name || "-"}
                    </TxtSpan>
                  </TableBodyCell>

                  {/* <TableBodyCell padding="16px 20px">
                    <TxtSpan color="#64748b">
                      {doc?.document_date
                        ? doc.document_date.split(" ")[0]
                        : "-"}
                    </TxtSpan>
                  </TableBodyCell> */}
                  <TableBodyCell padding="16px 20px">
                    <TxtSpan color="#64748b">
                      {doc?.document_date
                        ? moment(doc.document_date).format("MM-DD-YYYY")
                        : "-"}
                    </TxtSpan>
                  </TableBodyCell>


                  <TableBodyCell padding="16px 20px">
                    <TxtSpan fontWeight="600" color="#1e293b">
                      $ {parseFloat(doc?.insurance_balance || 0).toFixed(2)}
                    </TxtSpan>
                  </TableBodyCell>

                  <TableBodyCell padding="16px 0px">
                    <Div display="flex" gap="8px" justifyContent="center">
                      <NewActionButton
                        variant="outline"
                        onClick={() => handleDownload(doc?.pdf_link, doc?.id)}
                      >
                        Download
                      </NewActionButton>
                      <NewActionButton
                        onClick={() => handleView(doc?.pdf_link)}
                      >
                        View
                      </NewActionButton>
                    </Div>
                  </TableBodyCell>
                </TableRow>
              ))
            ) : (
              // ✅ Show empty state if no data is available
              <TableRow>
                <TableBodyCell colSpan={5} textAlign="center">
                  <EmptyData />
                </TableBodyCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </Div>
  );
};

export default StatementTable;
